import { useParams } from "react-router-dom";
import ComparisonForm from "./ComparisonForm";

export default function EditComparison() {
  const { comparison_id } = useParams();
  return <ComparisonForm comparisonId={comparison_id} />;
}
